import {
    ADD_GIFT_ITEM_TO_CART, ADD_GIFT_ITEMS_TO_CART,
    ADD_ITEM_TO_CART, CART_RESET_SPECIAL_CATEGORY, CART_SET_SPECIAL_CATEGORY,
    HIDE_CART_ITEM, REMOVE_GIFT_ITEM_FROM_CART,
    REMOVE_ITEM_FROM_CART, REMOVE_SELECTED_GIFT_ITEM,
    RESET_CART, SELECT_GIFT_ITEM,
    SET_CART,
    SHOW_CART_ITEM, UPDATE_CART_ITEM, UPDATE_SELECTED_GIFT_ITEM
} from '../actions/cart.actions';

const getCartStorage = () => {
    const data = sessionStorage.getItem(`${window.vendor}@cart@data`);
    return !data ? [] : JSON.parse(data);
};

const setCartStorage = (value) => {
    sessionStorage.setItem(`${window.vendor}@cart@data`, JSON.stringify(value));
};

const getCartGiftStorage = () => {
    const data = sessionStorage.getItem(`${window.vendor}@cart@gift`);
    return !data ? [] : JSON.parse(data);
};

const setCartGiftStorage = (value) => {
    sessionStorage.setItem(`${window.vendor}@cart@gift`, JSON.stringify(value));
};

const initialState = {
    items: [...getCartStorage()],
    giftItems: [...getCartGiftStorage()],
    selectedItem: null,
    specialCategory: null,
    selectedGiftItems: {},
};

const CartReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_ITEM_TO_CART:
        {
            const items = [
                ...state.items,
                action.payload
            ];
            setCartStorage([
                ...items
            ]);

            const giftItems = state.giftItems.filter(gift => action.giftItemsIds.includes(gift.id));
            setCartGiftStorage([
                ...giftItems
            ]);

            const giftItemsIds = giftItems.map(gift => gift.id);
            const selectedGiftItems = {...state.selectedGiftItems};
            Object.keys(selectedGiftItems).forEach(key => {
                if (giftItemsIds.includes(+key)) {
                    return;
                }

                delete selectedGiftItems[key];
            });

            return {
                ...state,
                items: [
                    ...items
                ],
                giftItems: [
                    ...giftItems
                ],
                selectedGiftItems: {
                    ...selectedGiftItems
                },
            };
        }
        case REMOVE_ITEM_FROM_CART:
        {
            const items = state.items.filter((item, index) => index !== action.payload);
            setCartStorage([
                ...items
            ]);

            const giftItems = state.giftItems.filter(gift => action.giftItemsIds.includes(gift.id));
            setCartGiftStorage([
                ...giftItems
            ]);

            const giftItemsIds = giftItems.map(gift => gift.id);
            const selectedGiftItems = {...state.selectedGiftItems};
            Object.keys(selectedGiftItems).forEach(key => {
                if (giftItemsIds.includes(+key)) {
                    return;
                }

                delete selectedGiftItems[key];
            });

            return {
                ...state,
                items: [
                    ...items
                ],
                giftItems: [
                    ...giftItems
                ],
                selectedGiftItems,
            };
        }
        case RESET_CART:
            setCartStorage([]);
            setCartGiftStorage([]);
            return {
                ...state,
                items: [],
                giftItems: [],
                selectedGiftItems: initialState.selectedGiftItems,
            };
        case SET_CART:
            setCartStorage([...action.payload]);
            setCartGiftStorage([]);
            return {
                ...state,
                items: [...action.payload],
                giftItems: [],
                selectedGiftItems: initialState.selectedGiftItems,
            };
        case SHOW_CART_ITEM:
            return {
                ...state,
                selectedItem: state.items.find((item, index) => index === action.payload)
            };
        case HIDE_CART_ITEM:
            return {
                ...state,
                selectedItem: null
            };
        case UPDATE_CART_ITEM:
        {
            const items = [...state.items];
            items.splice(
                items.findIndex(item => item.id === action.payload.id),
                1,
                action.payload
            );
            setCartStorage([
                ...items
            ]);

            const giftItems = state.giftItems.filter(gift => action.giftItemsIds.includes(gift.id));
            setCartGiftStorage([
                ...giftItems
            ]);

            const giftItemsIds = giftItems.map(gift => gift.id);
            const selectedGiftItems = {...state.selectedGiftItems};
            Object.keys(selectedGiftItems).forEach(key => {
                if (giftItemsIds.includes(+key)) {
                    return;
                }

                delete selectedGiftItems[key];
            });
            
            return {
                ...state,
                selectedItem: null,
                items: [
                    ...items
                ],
                giftItems: [
                    ...giftItems
                ],
                selectedGiftItems,
            };
        }
        case CART_SET_SPECIAL_CATEGORY:
            return {
                ...state,
                specialCategory: action.payload
            };
        case CART_RESET_SPECIAL_CATEGORY:
            return {
                ...state,
                specialCategory: null
            };
        case ADD_GIFT_ITEM_TO_CART:
            setCartGiftStorage([
                ...state.giftItems,
                action.payload
            ]);
            return {
                ...state,
                giftItems: [
                    ...state.giftItems,
                    action.payload
                ]
            };
        case REMOVE_GIFT_ITEM_FROM_CART:
            setCartGiftStorage([
                ...state.giftItems.filter((item, index) => index !== action.payload)
            ]);
            return {
                ...state,
                giftItems: [
                    ...state.giftItems.filter((item, index) => index !== action.payload)
                ]
            };
        case ADD_GIFT_ITEMS_TO_CART:
            setCartGiftStorage([
                ...action.payload
            ]);
            return {
                ...state,
                giftItems: [
                    // ...state.giftItems,
                    ...action.payload
                ]
            };
        case SELECT_GIFT_ITEM:
            return {
                ...state,
                selectedGiftItems: {
                    ...state.selectedGiftItems,
                    [action.payload.giftId]: [
                        ...(state.selectedGiftItems[action.payload.giftId] || []),
                        {
                            ...action.payload.item
                        }
                    ]
                }
            };
        case UPDATE_SELECTED_GIFT_ITEM: {
            const items = [...(state.selectedGiftItems[action.payload.giftId] || [])];
            items.splice(
                items.findIndex(item => item.id === action.payload.item.id),
                1,
                action.payload.item
            );
            
            return {
                ...state,
                selectedItem: null,
                selectedGiftItems: {
                    ...state.selectedGiftItems,
                    [action.payload.giftId]: [
                        ...items
                    ]
                }
            };
        }
        case REMOVE_SELECTED_GIFT_ITEM: {
            const items = [...(state.selectedGiftItems[action.payload.giftId] || [])];
            items.splice(
                items.findIndex(item => item.id === action.payload.item.id),
                1
            );
            
            return {
                ...state,
                selectedItem: null,
                selectedGiftItems: {
                    ...state.selectedGiftItems,
                    [action.payload.giftId]: [
                        ...items
                    ]
                }
            };
        }
        default:
            return state;
    }
};

export default CartReducer;